/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { APIMessageSchema } from './api-message-schema';
import { APIPaginationCursorBasedSchema } from './api-pagination-schema';

export const createApiResponseSchema = <T extends z.ZodTypeAny>(dataSchema?: T) => {
  return z.object({
    success: z.boolean(),
    data: dataSchema ? dataSchema.optional() : z.unknown().optional(),
    messages: z.array(APIMessageSchema).optional(),
    pagination: APIPaginationCursorBasedSchema.optional(),
    meta: z.record(z.string(), z.unknown()).optional(),
  });
};

// biome-ignore lint/style/useNamingConvention: Matches maxCertificate convention
export type IAPI<T = unknown> = {
  success: boolean;
  data?: T;
  messages?: Array<z.infer<typeof APIMessageSchema>>;
  pagination?: z.infer<typeof APIPaginationCursorBasedSchema>;
  meta?: Record<string, unknown>;
};
